/**
 * Module dependencies.
 */

import { Balloon } from 'src/core/advisor-config/balloons';
import { ReactElement } from 'react';
import { units } from '@untile/react-components';
import BalloonCard from 'src/components/cards/balloon-card';
import map from 'lodash/map';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  balloons: Balloon[];
  className?: string;
};

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  overflow: auto;
  position: relative;
  width: 100%;
`;

/**
 * `List` styled component.
 */

const List = styled.div`
  display: grid;
  grid-column-gap: ${units(8.5)};
  grid-template-columns: repeat(2, 1fr);
  overflow: auto;
`;

/**
 * `ResultsList` component.
 */

const ResultsList = ({ balloons, className }: Props): ReactElement => (
  <Wrapper className={className}>
    <List>
      {map(balloons, (baloon, index) => (
        <BalloonCard
          key={index}
          {...baloon}
        />
      ))}
    </List>
  </Wrapper>
);

/**
 * Export `ResultsList` component.
 */

export default ResultsList;
